import React from 'react'
import { toast } from 'react-toastify'

function errorNotification(errorMessage) {
  toast.dismiss()
  return (
    toast(errorMessage, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      type: "error",
    })
  )
}

export default errorNotification